import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { useLanguage } from '../../contexts/LanguageContext';
import MapIcon from '@mui/icons-material/Map';
import MovieCreationOutlinedIcon from '@mui/icons-material/MovieCreationOutlined';
import AddIcon from '@mui/icons-material/Add';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import PersonIcon from '@mui/icons-material/Person';
import CategorySelectionModal from '../InputPages/CategorySelectionModal';

const BottomNavigation = ({ mode = 'home', onHome, onExplore, onShowSaved, savedActive = false, onShowProfile }) => {
  const { language } = useLanguage();
  const [categoryModalOpen, setCategoryModalOpen] = useState(false);

  const getMenuTexts = () => {
    switch (language) {
      case 'TH':
        return { home: 'แผนที่', trend: 'สำรวจ', add: 'เพิ่ม', message: 'ที่บันทึกไว้', profile: 'โปรไฟล์' };
      case 'CN':
        return { home: '地图', trend: '探索', add: '添加', message: '已保存', profile: '个人资料' };
      default:
        return { home: 'Map', trend: 'Explore', add: '+', message: 'Saved', profile: 'Me' };
    }
  };

  const menuTexts = getMenuTexts();

  const menuItems = [
    { key: 'home',    text: menuTexts.home,    icon: <MapIcon fontSize="small" /> },
    { key: 'trend',   text: menuTexts.trend,   icon: <MovieCreationOutlinedIcon fontSize="small" /> },
    { key: 'add',     text: menuTexts.add,     icon: <AddIcon fontSize="small" /> },
    { key: 'message', text: menuTexts.message, icon: savedActive ? <BookmarkIcon fontSize="small" /> : <BookmarkBorderIcon fontSize="small" /> },
    { key: 'profile', text: menuTexts.profile, icon: <PersonIcon fontSize="small" /> },
  ];

  const handleMenuClick = (key) => {
    switch (key) {
      case 'home':
        if (onHome) onHome();
        break;
      case 'trend':
        if (onExplore) onExplore();
        break;
      case 'add':
        setCategoryModalOpen(true);
        break;
      case 'message':
        if (onShowSaved) onShowSaved();
        break;
      case 'profile':
        if (onShowProfile) onShowProfile();
        break;
      default:
        break;
    }
  };

  const isSavedActive = (key) => key === 'message' && savedActive;
  const isNavActive = (key) =>
    (key === 'home' && mode !== 'verticalExplore') ||
    (key === 'trend' && mode === 'verticalExplore') ||
    isSavedActive(key);

  return (
    <>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        mx: 0,
        minHeight: 60,
        px: 'max(10px, env(safe-area-inset-left))',
        pb: 'env(safe-area-inset-bottom)',
        backgroundColor: 'rgba(255, 255, 255, 0.96)',
        borderTopLeftRadius: 22,
        borderTopRightRadius: 22,
        boxShadow: '0 -8px 26px rgba(31, 41, 55, 0.14)',
        borderTop: '1px solid rgba(229, 231, 235, 0.9)',
        backdropFilter: 'blur(18px)'
      }}>
        {menuItems.map(({ key, text, icon }) => (
          <IconButton
            key={key}
            onClick={() => handleMenuClick(key)}
            sx={{
              flex: 1,
              py: key === 'add' ? 0 : 0.75,
              px: 0.5,
              borderRadius: key === 'add' ? '50%' : 3,
              flexDirection: 'column',
              color: isNavActive(key) ? '#7c3aed' : '#5f6675',
              maxWidth: 74,
              minWidth: 0,
              ...(key === 'add' && {
                flex: '0 0 62px',
                width: 56,
                height: 56,
                maxWidth: 62,
                mt: -3,
                mx: 0.5,
                color: '#ffffff',
                background: 'linear-gradient(135deg, #6d4cff 0%, #c044ff 100%)',
                boxShadow: '0 10px 24px rgba(109, 76, 255, 0.32)',
              }),
              '&:hover': {
                backgroundColor: key === 'add' ? undefined : 'rgba(124, 58, 237, 0.08)'
              }
            }}
          >
            <Box sx={{ display: 'grid', placeItems: 'center', '& svg': { fontSize: key === 'add' ? 34 : 22 } }}>
              {icon}
            </Box>
            <Box sx={{
              display: key === 'add' ? 'none' : 'block',
              fontSize: '0.64rem',
              mt: 0.25,
              lineHeight: 1,
              fontWeight: isNavActive(key) ? 700 : 600,
              whiteSpace: 'nowrap'
            }}>
              {text}
            </Box>
          </IconButton>
        ))}
      </Box>
      <CategorySelectionModal
        open={categoryModalOpen}
        onClose={() => setCategoryModalOpen(false)}
        language={language}
      />
    </>
  );
};

export default BottomNavigation;
